<template>
	<div>
		<div class="filter-bar" :class="{slideOut: !isOpen}" ref="filterBar">
			<b-form @submit.prevent="apply()" inline :class="{fadeIn: isOpen, fadeOut: !isOpen}">
				<div class="fields" :class="isInline ? 'flex-space-between' : ''">
					<slot></slot>
				</div>
				<div>
					<b-button type="submit" variant="primary">Filtrar</b-button>
					<b-button @click="clear()" variant="primary">Limpar</b-button>
				</div>
			</b-form>
		</div>

		<i @click="isOpen = !isOpen" class="tab material-icons">{{isOpen ? 'close' : 'search'}}</i>
		<i @click="$emit('apply')" class="tab material-icons bg-primary" title="Atualizar listagem">refresh</i>
	</div>
</template>

<script>
export default {
	props: ['inline'],
	data() {
		return {
			isOpen: true,
		};
	},
	mounted() {
		let bar = this.$refs.filterBar;
		bar.style.height = bar.scrollHeight + 40 +'px';
	},
	computed: {
		isInline() {
			return this.inline || this.inline === '';
		}
	},
	methods: {
		toggleFilterBar() {
		},
		apply() {
			this.$emit('apply');
		},
		clear() {
			this.$emit('clear');
		}
	}
}
</script>

<style scoped>
.filter-bar {
	margin: 0 40px;
	box-sizing: border-box;
	height: auto;
	overflow: hidden;

	transition: height 600ms;
	border-radius: 0 0 15px 15px;
}

.fields .filter-input {
  color: white;
  font-weight: bold;
}

form {
	margin: 20px;
}

.filter-bar, .tab {
	background: #163247;
}

.fadeIn {
	opacity: 1;
	transition: margin 300ms 300ms, opacity 300ms 300ms;
}

.fadeOut {
	opacity: 0;
	margin-top: 0;
	margin-bottom: 0;
	transition: margin 300ms, opacity 300ms;
}

.slideOut {
	height: 0 !important;
}

.tab {
	display: inline-block;
	padding: 5px;
	color: white;
	cursor: pointer;
	border-radius: 0 0 5px 5px;
	position: relative;
	left: 70px;
}

.fields {
	flex: 1;
	margin-right: 20px;
	padding-right: 20px;
	border-right: 1px solid #ced4da;
}

.flex-space-between {
	display: flex;
	justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/FilterBar.vue